import styles from './Card.module.css';

export function Card({ className = '', children, ...rest }) {
  return (
    <div className={`${styles.card} ${className}`.trim()} {...rest}>
      {children}
    </div>
  );
}
